{
  "seo": {
    "homeTitle": "Que faire sur la Côte d'Azur : agenda, excursions, bateaux",
    "homeDescription": "Que faire sur la Côte d'Azur : concerts et spectacles, excursions, dégustations de vin et location de bateaux à Nice, Cannes, Monaco et Antibes.",
    "homeImageAlt": "Èze et la côte de la Côte d'Azur au coucher du soleil",
    "toursTitle": "Excursions et visites guidées sur la Côte d'Azur",
    "toursDescription": "Excursions et visites sur la Côte d'Azur au départ de Nice, Cannes, Monaco et Antibes : Èze et Monaco, villages de Provence, vin, sorties en bateau.",
    "eventsTitle": "Événements sur la Côte d'Azur — Riviera To-Do",
    "eventsDescription": "Concerts, expositions, théâtre et festivals à Nice, Cannes, Monaco et sur toute la Côte d'Azur — dates et billetterie.",
    "articlesTitle": "Guide de la Côte d'Azur — articles et conseils",
    "articlesDescription": "Guide de la Côte d'Azur : festivals au fil des saisons, vins et spécialités, yachts et plages, excursions et conseils pratiques à Nice, Cannes et Monaco.",
    "citiesTitle": "Les villes de la Côte d'Azur — Riviera To-Do",
    "citiesDescription": "Nice, Cannes, Monaco, Antibes, Saint-Tropez, Menton et Villefranche-sur-Mer : découvrez événements, excursions et activités dans chaque ville de la Côte d'Azur.",
    "boatsTitle": "Location de bateau sur la Côte d'Azur — avec ou sans permis",
    "boatsDescription": "Louez un bateau à moteur, semi-rigide, yacht, voilier ou catamaran sur la Côte d'Azur, avec ou sans skipper, à Cannes, Antibes, Saint-Tropez, Nice et Monaco."
  },
  "app": {
    "logIn": "Se connecter"
  },
  "nav": {
    "events": "Événements",
    "tours": "Excursions",
    "wineTours": "Œnotourisme",
    "boats": "Yachts et bateaux",
    "hotels": "Hôtels",
    "articles": "Articles",
    "cities": "Villes"
  },
  "a11y": {
    "language": "Langue",
    "favorites": "Favoris",
    "menu": "Menu",
    "closeMenu": "Fermer le menu",
    "home": "Aller à la page d'accueil",
    "back": "Retour",
    "previous": "Précédent",
    "next": "Suivant",
    "addFavorite": "Ajouter aux favoris",
    "removeFavorite": "Retirer des favoris"
  },
  "common": {
    "seeAll": "Voir tout",
    "wholeRegion": "Toute la région",
    "allCategories": "Toutes les catégories",
    "fromPrice": "à partir de {{price}}",
    "inCity": " à {{city}}",
    "notFound": "Page introuvable.",
    "home": "Accueil",
    "showMore": "Afficher plus",
    "loadingMore": "Chargement…",
    "loadMoreError": "Impossible de charger la suite. Veuillez réessayer."
  },
  "dates": {
    "today": "aujourd'hui",
    "tomorrow": "demain",
    "thisWeekend": "ce week-end",
    "on": "le {{date}}"
  },
  "filters": {
    "chooseCity": "Choisir une ville",
    "filterByDate": "Filtrer par date",
    "showAllEvents": "Voir tous les événements",
    "resetFilters": "Réinitialiser les filtres"
  },
  "dateFilters": {
    "alltime": "Toutes les dates",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "weekend": "Ce week-end",
    "custom": "Choisir une date"
  },
  "categories": {
    "concerts": "Concerts",
    "theatre": "Théâtre",
    "exhibitions": "Expositions",
    "parties": "Fêtes",
    "gastronomy": "Gastronomie",
    "festivals": "Festivals",
    "sport": "Sport",
    "family": "Famille",
    "cinema": "Cinéma",
    "other": "Autre"
  },
  "categoryLabels": {
    "concerts": "Concert",
    "exhibitions": "Exposition",
    "parties": "Fête",
    "theatre": "Théâtre",
    "gastronomy": "Gastronomie",
    "festivals": "Festival",
    "sport": "Sport",
    "family": "Famille",
    "cinema": "Cinéma",
    "other": "Autre",
    "fallback": "Événement"
  },
  "categoryNouns": {
    "all": "événements",
    "concerts": "concerts",
    "theatre": "pièces de théâtre",
    "exhibitions": "expositions",
    "parties": "fêtes",
    "gastronomy": "événements gastronomiques",
    "festivals": "festivals",
    "sport": "événements sportifs",
    "family": "événements pour la famille",
    "cinema": "séances de cinéma",
    "other": "événements"
  },
  "home": {
    "heroTitle": "La Côte d'Azur",
    "heroSubtitle": "Tous les événements de la Côte d'Azur au même endroit",
    "findEvents": "Trouver des événements",
    "statCities_one": "{{count}} ville",
    "statCities_other": "{{count}} villes",
    "statCategories_one": "{{count}} catégorie",
    "statCategories_other": "{{count}} catégories",
    "eventsNoun_one": "événement",
    "eventsNoun_other": "événements"
  },
  "cityHero": {
    "events_one": "{{display}} événement",
    "events_other": "{{display}} événements",
    "tours_one": "{{display}} excursion",
    "tours_other": "{{display}} excursions",
    "boats_one": "{{display}} bateau",
    "boats_other": "{{display}} bateaux"
  },
  "events": {
    "heading": "Top {{noun}}{{where}}{{when}}",
    "loading": "Chargement des événements…",
    "empty": "Aucun événement trouvé.",
    "aboutEvent": "À propos de cet événement",
    "moreUpcomingCity": "Prochains événements à {{city}}",
    "moreUpcoming": "Prochains événements",
    "getTickets": "Obtenir des billets",
    "free": "Gratuit",
    "loadingOne": "Chargement de l'événement…",
    "loadError": "Impossible de charger l'événement : {{error}}",
    "notFound": "Événement introuvable.",
    "attributionFnac": "Billetterie par Fnac Spectacles.",
    "headingRegion": "À l'affiche sur la Côte d'Azur",
    "headingCity": "À l'affiche à {{city}}",
    "subheading": "Concerts, expositions, théâtre et festivals — dates et billetterie.",
    "endedBanner": "Cet événement est terminé",
    "endedHint": "Découvrez les prochains événements ci-dessous.",
    "datesHeading": "Dates et billets",
    "tickets": "Billets",
    "moreDates_one": "+{{count}} autre date",
    "moreDates_other": "+{{count}} autres dates",
    "showAllDates": "Voir toutes les dates ({{count}})",
    "showFewerDates": "Voir moins de dates",
    "moved": "Cette page d'événement a été déplacée.",
    "movedLink": "Voir la page de l'événement"
  },
  "tours": {
    "headingRegion": "Excursions et visites sur la Côte d'Azur",
    "headingCity": "Excursions et expériences à {{city}}",
    "subheading": "Des expériences, excursions et sorties à la journée triées sur le volet — réservées sur Viator.",
    "loading": "Chargement des expériences…",
    "empty": "Aucune expérience trouvée.",
    "badge": "Expérience",
    "viaViator": "via Viator",
    "book": "Réserver",
    "aboutExperience": "À propos de cette expérience",
    "moreInCity": "Plus d'excursions à {{city}}",
    "more": "Plus d'excursions",
    "moreWineInCity": "Plus d'excursions œnologiques à {{city}}",
    "moreWine": "Plus d'excursions œnologiques",
    "perPerson": "par personne",
    "reviews_one": "{{count}} avis",
    "reviews_other": "{{count}} avis",
    "loadingOne": "Chargement de l'expérience…",
    "loadError": "Impossible de charger l'expérience : {{error}}",
    "notFound": "Expérience introuvable.",
    "delistedBanner": "Cette activité n'est plus disponible",
    "delistedHint": "Elle ne peut plus être réservée. Découvrez d'autres activités ci-dessous."
  },
  "boats": {
    "headingRegion": "Location de bateaux et yachts sur la Côte d'Azur",
    "headingCity": "Location de yachts et bateaux à {{city}}",
    "subheading": "Bateaux à moteur, voiliers et yachts — réservation directe avec Click&Boat.",
    "loading": "Chargement des bateaux…",
    "empty": "Aucun bateau trouvé.",
    "emptyInCity": "Aucun bateau trouvé à {{city}}.",
    "badge": "Location de bateau",
    "viaClickAndBoat": "via Click&Boat",
    "book": "Réserver",
    "aboutBoat": "À propos de ce bateau",
    "moreInCity": "Plus de bateaux à {{city}}",
    "more": "Plus de bateaux",
    "perDay": "par jour",
    "loadingOne": "Chargement du bateau…",
    "loadError": "Impossible de charger le bateau : {{error}}",
    "notFound": "Bateau introuvable.",
    "delistedBanner": "Ce bateau n'est plus disponible",
    "delistedHint": "Il ne peut plus être réservé. Découvrez d'autres bateaux ci-dessous.",
    "faqHeading": "Location de bateau sur la Côte d'Azur : questions fréquentes",
    "facts": {
      "heading": "Caractéristiques du bateau",
      "type": "Type de bateau",
      "port": "Port de départ",
      "price": "Prix",
      "rating": "Note",
      "year": "Année de construction",
      "owner": "Propriétaire",
      "rentalBasis": "Base de location",
      "rentalBasisValue": "À la journée",
      "skipper": "Option skipper",
      "skipperValue": "Avec ou sans skipper",
      "passengers": "Passagers",
      "passengersValue": "Jusqu’à {{value}}",
      "length": "Longueur",
      "lengthValue": "{{value}} m",
      "cabins": "Cabines",
      "berths": "Couchages",
      "bathrooms": "Salles d’eau",
      "engine": "Moteur",
      "engineValue": "{{value}} ch",
      "licence": "Permis bateau",
      "licenceRequired": "Obligatoire",
      "licenceNotRequired": "Non requis",
      "skipperIncluded": "Skipper inclus",
      "skipperNotAvailable": "Sans skipper",
      "onBoard": "À bord"
    },
    "typeLabel": {
      "Motorboat": "Bateau à moteur",
      "Sailboat": "Voilier",
      "Catamaran": "Catamaran",
      "RIB": "Semi-rigide",
      "Motor yacht": "Yacht à moteur",
      "Houseboat": "Péniche",
      "Boat without licence": "Bateau sans permis",
      "Jet ski": "Jet-ski",
      "Sailing yacht": "Yacht à voile"
    },
    "ownerLabel": {
      "professional": "Professionnel",
      "private": "Particulier"
    },
    "template": {
      "title": "Location de {{type}} à {{city}} — {{name}}",
      "description": "{{name}} est un {{type}} disponible à la location à {{city}} sur la Côte d'Azur, à partir de {{price}} € par jour, avec ou sans skipper.",
      "summary": "Location de {{type}} à {{city}} dès {{price}} €/jour — {{name}} sur la Côte d'Azur.",
      "priceSuffix": "À partir de {{price}} €/jour."
    },
    "cityIntro": {
      "nice": "La location de bateaux à Nice s'organise principalement depuis le port de Nice et la baie des Anges, avec un accès facile aux eaux calmes qui s'étendent vers le Cap d'Antibes et la frontière italienne. Bateaux à moteur et semi-rigides sont les choix les plus courants pour une journée en mer, idéaux pour rejoindre Villefranche-sur-Mer ou les îles de Lérins. L'été (juin à septembre) offre la mer la plus calme et l'eau la plus chaude, tandis que le printemps et le début de l'automne permettent d'éviter l'affluence de la haute saison dans la baie.",
      "cannes": "Cannes propose des départs depuis deux points principaux — le Vieux Port au pied du Palais des Festivals, et Mandelieu-la-Napoule à proximité — ce qui place les îles de Lérins, couvertes de pins, à une courte traversée. Yachts à moteur et bateaux à moteur dominent la flotte, à l'image de la réputation glamour de la ville, aux côtés de nombreux semi-rigides adaptés aux familles. Mai et juin sont les mois les plus fréquentés en raison du Festival, tandis que juillet et août offrent les conditions méditerranéennes les plus stables pour une journée complète en mer.",
      "antibes": "Antibes et ses voisines Golfe-Juan et Juan-les-Pins forment l'un des pôles nautiques les plus actifs de la Côte d'Azur, autour du Port Vauban, l'une des plus grandes marinas d'Europe. Voiliers et bateaux à moteur y sont tous deux bien représentés, adaptés aussi bien aux courtes sorties autour du Cap d'Antibes qu'aux traversées plus longues vers les îles de Lérins. Les eaux relativement abritées de la baie en font un cadre clément pour une première location sans skipper.",
      "villefranche": "La baie profonde et abritée de Villefranche-sur-Mer — l'un des ports naturels les plus calmes du littoral — en fait un point de départ apprécié pour rejoindre le Cap Ferrat, Beaulieu-sur-Mer et la frontière italienne. Semi-rigides et bateaux à moteur conviennent particulièrement aux itinéraires courts et panoramiques autour du cap. La profondeur de la baie maintient des conditions calmes même lorsque la mer se forme plus au large, un atout pour les locataires les moins expérimentés.",
      "monaco": "Les locations de bateaux à Monaco partent de la principauté elle-même ou des ports voisins de Cap-d'Ail et Monte-Carlo, plaçant Menton et la Riviera italienne à portée le long de la côte. La flotte y est plutôt haut de gamme, avec des yachts à moteur aux côtés des bateaux à moteur, à l'image de la réputation de Monaco comme port de superyachts. La mer calme en été et les courtes distances de traversée conviennent aussi bien à un après-midi avec skipper qu'à une journée plus longue en autonomie.",
      "menton": "Menton, ville la plus orientale de la Côte d'Azur, offre une alternative plus tranquille à Nice ou Cannes pour la location de bateaux, avec des départs depuis le petit port de la ville et le quartier voisin de Menton-Garavan. C'est une base naturelle pour explorer les eaux calmes vers Monaco ou rejoindre les villes côtières italiennes toutes proches. La faible affluence convient aussi bien aux locataires débutants qu'à ceux recherchant une journée sans le trafic dense des grandes marinas.",
      "sttropez": "Saint-Tropez et sa baie élargie — incluant Sainte-Maxime, Grimaud, Port Grimaud, Cogolin, Cavalaire-sur-Mer et Ramatuelle — forment le plus grand pôle de location de bateaux de la Côte d'Azur, avec le plus large choix de types de bateaux, des semi-rigides aux voiliers en passant par les yachts à moteur. Le golfe abrité de Saint-Tropez maintient des conditions maniables la majeure partie de la saison, et la plage de Pampelonne ainsi que les îles d'Hyères sont des destinations prisées pour une sortie à la journée. Juillet et août sont les mois les plus chargés : mieux vaut réserver à l'avance."
    },
    "faq": [
      {
        "q": "Faut-il un permis bateau pour louer un bateau ?",
        "a": "Pas toujours. De nombreux bateaux sur Click&Boat peuvent être loués avec skipper inclus, auquel cas aucun permis n'est nécessaire — repérez l'option « avec skipper » sur chaque annonce. Louer sans skipper nécessite en général un permis bateau valide, adapté à la taille et à la puissance du moteur."
      },
      {
        "q": "Une caution ou une assurance sont-elles exigées ?",
        "a": "Oui. Click&Boat demande une caution pour la plupart des locations, et chaque réservation inclut une assurance responsabilité civile couvrant le bateau et les passagers pendant la durée de la location. Le montant de la caution et les conditions d'assurance varient selon le bateau et sont indiqués sur chaque annonce avant la réservation."
      },
      {
        "q": "Qu'est-ce qui est inclus dans le prix ?",
        "a": "Le tarif journalier affiché couvre généralement le bateau et l'équipement de sécurité de base. Le carburant, un skipper (si sélectionné) et les options supplémentaires sont en général facturés séparément — vérifiez l'annonce concernée sur Click&Boat pour savoir précisément ce qui est inclus avant de réserver."
      },
      {
        "q": "Puis-je annuler ou modifier ma réservation ?",
        "a": "Les conditions d'annulation sont fixées par chaque propriétaire et affichées au moment du paiement sur Click&Boat. De nombreuses annonces proposent une annulation gratuite jusqu'à un certain nombre de jours avant le départ — consultez les conditions sur la page du bateau choisi."
      },
      {
        "q": "Quelle est la saison du bateau sur la Côte d'Azur ?",
        "a": "La plupart des bateaux se louent du printemps à l'automne, avec un pic en juillet et en août — réservez tôt pour ces semaines-là. Beaucoup de propriétaires louent aussi en mai, juin et septembre, quand les criques et les mouillages sont plus calmes."
      }
    ],
    "equipment": {
      "air_conditioning": "Climatisation",
      "generator": "Groupe électrogène",
      "bimini": "Bimini (taud de soleil)",
      "sun_pads": "Bains de soleil",
      "swim_platform": "Plateforme de bain",
      "swim_ladder": "Échelle de bain",
      "deck_shower": "Douche de pont",
      "toilet": "WC",
      "kitchen": "Cuisine",
      "fridge": "Réfrigérateur",
      "sound_system": "Système audio",
      "tv": "Télévision",
      "wifi": "Wi-Fi",
      "gps": "GPS",
      "autopilot": "Pilote automatique",
      "bow_thruster": "Propulseur d’étrave",
      "anchor_windlass": "Guindeau",
      "tender": "Annexe",
      "paddle_board": "Paddle",
      "snorkelling_gear": "Matériel de snorkeling",
      "kayak": "Kayak",
      "water_skis": "Skis nautiques",
      "wakeboard": "Wakeboard",
      "towable": "Bouée tractée",
      "seabob": "Scooter sous-marin",
      "fishing_gear": "Matériel de pêche"
    }
  },
  "crossSell": {
    "headingCity": "Excursions et location de bateau {{inCity}}",
    "heading": "Excursions et location de bateau sur la Côte d'Azur"
  },
  "hotels": {
    "eventHeading": "Vous restez dormir ?",
    "nearVenue": "Hôtels près de {{venue}}",
    "inCity": "Hôtels {{inCity}}",
    "dates": "{{checkin}} → {{checkout}}",
    "cta": "Voir les hôtels",
    "ctaCity": "Voir les hôtels {{inCity}}",
    "showMap": "Voir les hôtels sur la carte",
    "hideMap": "Masquer la carte",
    "mapTitle": "Carte des hôtels à proximité",
    "sectionHeading": "Où dormir {{inCity}}",
    "sectionText": "Hôtels, appartements et chambres d'hôtes {{inCity}}, avec les prix pour vos dates sur les principaux sites de réservation."
  },
  "articles": {
    "latest": "Derniers articles",
    "loading": "Chargement des articles…",
    "loadError": "Impossible de charger les articles : {{error}}",
    "badge": "Article",
    "readArticle": "Lire l'article",
    "loadingOne": "Chargement de l'article…",
    "loadErrorOne": "Impossible de charger l'article : {{error}}",
    "notFound": "Article introuvable.",
    "headingRegion": "Guide de la Côte d'Azur",
    "subheading": "Guides, conseils et récits pour préparer votre séjour.",
    "empty": "Aucun article pour le moment.",
    "planHeading": "Organisez votre séjour",
    "moreHeading": "À lire aussi",
    "topics": {
      "wine": "Vin",
      "food": "Gastronomie",
      "festivals": "Festivals et événements",
      "seasonal": "Guides de saison",
      "boats": "Bateaux et plages",
      "tours": "Excursions",
      "culture": "Culture et patrimoine",
      "practical": "Conseils pratiques"
    }
  },
  "citiesHub": {
    "heading": "Les villes de la Côte d'Azur",
    "intro": [
      "La Côte d'Azur s'étire le long de la Méditerranée, de Saint-Tropez à l'ouest jusqu'à Menton, à la frontière italienne. Ses villes sont proches les unes des autres, mais chacune a son caractère : Nice est la capitale animée, Cannes et Monaco jouent la carte du glamour, Antibes et Villefranche-sur-Mer sont plus petites et plus paisibles, Saint-Tropez est le terrain de jeu de l'été et Menton la plus tranquille de toutes.",
      "La plupart sont desservies par la même ligne ferroviaire côtière : on peut facilement séjourner dans une ville et découvrir les autres à la journée. Choisissez une ville ci-dessous pour voir ses prochains événements, ses excursions et ses activités."
    ],
    "taglines": {
      "nice": "La capitale de la Riviera : vieille ville, musées, aéroport et trains dans toutes les directions.",
      "cannes": "Le glamour du Festival sur la Croisette, et des bateaux pour les îles de Lérins.",
      "monaco": "Casino, Grand Prix et superyachts dans le port, sur deux kilomètres carrés.",
      "antibes": "Remparts, musée Picasso et festival de jazz estival de Juan-les-Pins.",
      "sttropez": "Le chic du Vieux-Port, les plages de Pampelonne et les vignes de rosé tout autour.",
      "menton": "Le bout de la côte, calme et ensoleillé : jardins, citrons et l'Italie à deux pas.",
      "villefranche": "Un petit port sur l'une des rades les plus profondes et les plus abritées de la Riviera."
    },
    "faqHeading": "Villes de la Côte d'Azur : questions fréquentes",
    "faq": [
      {
        "q": "Quelle ville choisir comme point de chute sur la Côte d'Azur ?",
        "a": "Pour un premier séjour, Nice : elle a l'aéroport, le plus grand choix d'hôtels et de restaurants, et des trains le long de la côte vers Cannes, Antibes, Villefranche-sur-Mer, Monaco et Menton. Cannes ou Antibes conviennent si vous préférez une ville plus petite à l'ouest, Menton ou Villefranche-sur-Mer pour un séjour plus calme à l'est. Saint-Tropez se visite plutôt pour elle-même que comme camp de base : elle est à l'écart de la voie ferrée et loin de l'aéroport."
      },
      {
        "q": "Peut-on visiter la Côte d'Azur sans voiture ?",
        "a": "Oui, en grande partie. Les TER longent la côte de Cannes à Menton en passant par Antibes, Nice, Villefranche-sur-Mer et Monaco, puis continuent jusqu'à la frontière italienne, avec plusieurs trains par heure aux heures de pointe ; les bus locaux complètent le réseau. Saint-Tropez fait exception : sans gare, on s'y rend en voiture, en car depuis Saint-Raphaël ou en bateau, avec des liaisons saisonnières depuis Nice et Cannes."
      },
      {
        "q": "À quelle distance de l'aéroport de Nice se trouvent les villes ?",
        "a": "Le centre de Nice est à environ 25 minutes en tramway. En train depuis Nice, Villefranche-sur-Mer est à moins de 10 minutes, Antibes et Monaco à environ 20–25 minutes, Cannes à 30–40 minutes et Menton à 35–40 minutes. Saint-Tropez est à environ deux heures de route de l'aéroport, souvent davantage avec la circulation estivale."
      },
      {
        "q": "Quelle est la ville la plus calme, et la plus animée ?",
        "a": "Menton et Villefranche-sur-Mer sont les plus paisibles : petites, résidentielles et adaptées aux familles. Nice est la plus animée toute l'année, avec le calendrier de concerts, de spectacles et de festivals le plus chargé. Cannes et Monaco vivent au rythme de leurs grands rendez-vous — le Festival de Cannes en mai et le Grand Prix à la fin du printemps —, tandis que Saint-Tropez et Juan-les-Pins battent leur plein en juillet et en août."
      },
      {
        "q": "Quelle est la meilleure période pour visiter la Côte d'Azur ?",
        "a": "La fin du printemps (mai–juin) et le début de l'automne (septembre–octobre) offrent un temps chaud sans la foule de la haute saison. Juillet et août sont les mois les plus chauds et les plus fréquentés, quand les prix montent et que les festivals se succèdent. L'hiver est doux et calme, animé en février par le Carnaval de Nice et la Fête du Citron de Menton."
      }
    ],
    "imageAlt": "{{city}}, Côte d'Azur"
  },
  "hotelsPage": {
    "heading": "Où dormir sur la Côte d'Azur",
    "seoTitle": "Où dormir sur la Côte d'Azur : villes et carte des hôtels",
    "metaDescription": "Nice, Cannes, Monaco, Antibes, Saint-Tropez, Menton ou Villefranche ? Dans quelle ville et quel quartier loger, avec une carte des hôtels et appartements.",
    "intro": [
      "L'endroit où vous dormez compte beaucoup dans un séjour sur la Côte d'Azur. Le littoral s'étend de Saint-Tropez, à l'ouest, jusqu'à Menton, à la frontière italienne, et chaque ville a sa personnalité : Nice offre le plus grand choix et les meilleures connexions, Cannes et Monaco jouent la carte du glamour (et des prix élevés), Antibes et Menton sont plus petites et plus calmes, et Villefranche-sur-Mer est un village posé sur l'une des plus belles rades de la côte.",
      "La carte ci-dessous affiche les hôtels, appartements et chambres d'hôtes de toute la Riviera, avec les prix des principaux sites de réservation — choisissez une ville pour zoomer. Plus bas : dans quel quartier loger dans chaque ville, et pour quel type de séjour."
    ],
    "wholeRiviera": "Toute la Côte d'Azur",
    "showOnMap": "Voir sur la carte",
    "townsHeading": "Dans quelle ville loger",
    "cities": {
      "nice": {
        "name": "Nice",
        "text": "La meilleure base pour un premier séjour : l'aéroport est à environ 25 minutes en tramway et les trains longent la côte dans les deux sens. Logez dans le Vieux-Nice ou juste à côté pour être au milieu des restaurants et des marchés — animé, mais bruyant les nuits d'été. Les hôtels de la Promenade des Anglais ont la vue sur la mer ; le quartier de l'avenue Jean-Médecin et de la gare Nice-Ville est le choix pratique et plus abordable, et le quartier du Port, plus calme, a un vrai air de vie locale."
      },
      "cannes": {
        "name": "Cannes",
        "text": "Les hôtels se concentrent le long de la Croisette, des grands palaces du front de mer aux adresses plus modestes une ou deux rues en retrait. Le Suquet, la vieille ville perchée au-dessus du Vieux-Port, a plus de cachet, et le quartier de la rue d'Antibes et de la gare est central et souvent moins cher. Pendant le Festival de Cannes en mai et les grands salons, les prix s'envolent et tout est complet des mois à l'avance : Antibes, Juan-les-Pins ou Mandelieu-la-Napoule sont alors de bonnes alternatives."
      },
      "monaco": {
        "name": "Monaco",
        "text": "Monaco compte peu d'hôtels, parmi les plus chers de la côte, surtout autour du Casino de Monte-Carlo. Beaucoup de visiteurs logent juste de l'autre côté de la frontière, en France — à Beausoleil, à quelques minutes à pied au-dessus de Monte-Carlo, ou à Cap-d'Ail — ou s'installent à Nice, à 20–25 minutes en train. Pour le week-end du Grand Prix, réservez très tôt : les prix montent alors sur toute la Riviera Est."
      },
      "antibes": {
        "name": "Antibes",
        "text": "Le Vieil Antibes, la vieille ville dans ses remparts, est l'endroit où loger pour ses ruelles à parcourir à pied, son marché provençal et les yachts du Port Vauban. Juan-les-Pins, de l'autre côté du Cap, offre des plages de sable, des soirées plus tardives et le festival Jazz à Juan en juillet. Le Cap d'Antibes lui-même est préservé et haut de gamme — superbe, mais mieux vaut une voiture ou des taxis. Antibes et Juan-les-Pins ont chacune leur gare."
      },
      "sttropez": {
        "name": "Saint-Tropez",
        "text": "Les hôtels du village sont petits et haut de gamme, et atteignent leurs prix les plus élevés en juillet et en août. Les clubs de plage de Pampelonne sont à quelques kilomètres au sud, à Ramatuelle, qui a ses propres hôtels et villas. Pour un meilleur rapport qualité-prix, logez de l'autre côté du golfe, à Sainte-Maxime ou à Port Grimaud, et traversez en navette maritime. Pas de train : prévoyez une voiture, le bus depuis Saint-Raphaël ou le bateau."
      },
      "menton": {
        "name": "Menton",
        "text": "Le bout calme et ensoleillé de la côte, généralement plus abordable que Nice ou Cannes. Les hôtels bordent la promenade du front de mer et les rues au pied de la vieille ville ; Garavan, la baie côté frontière italienne, est plus paisible encore. Menton convient à un séjour tranquille comme à un long séjour d'hiver, et le train rejoint Monaco en une dizaine de minutes et Nice en 35 à 40 minutes."
      },
      "villefranche": {
        "name": "Villefranche-sur-Mer",
        "text": "Un petit village portuaire qui ne compte qu'une poignée d'hôtels : appartements et chambres d'hôtes forment une grande partie de l'offre. Logez près de la vieille ville et du port pour la vue sur la rade, ou cherchez du côté de Beaulieu-sur-Mer et de Saint-Jean-Cap-Ferrat pour des hôtels plus haut de gamme. Nice est à moins de 10 minutes en train, Monaco à environ 15."
      }
    },
    "faqHeading": "Où dormir sur la Côte d'Azur : questions fréquentes",
    "faq": [
      {
        "q": "Quelle est la meilleure ville où loger sur la Côte d'Azur ?",
        "a": "Pour un premier séjour, Nice : c'est là qu'on trouve le plus d'hôtels à tous les prix, l'aéroport est à deux pas et les trains desservent toute la côte, ce qui met les autres villes à portée d'excursion. Choisissez Cannes ou Monaco pour le glamour, Antibes pour une ville plus petite avec des plages, Menton ou Villefranche-sur-Mer pour un séjour au calme, et Saint-Tropez si les clubs de plage sont le but du voyage."
      },
      {
        "q": "Où loger sur la Côte d'Azur sans voiture ?",
        "a": "N'importe où le long de la ligne ferroviaire côtière : Cannes, Antibes, Juan-les-Pins, Nice, Villefranche-sur-Mer, Monaco et Menton ont toutes une gare, avec des TER plusieurs fois par heure aux heures de pointe. Choisissez un hôtel à distance de marche d'une gare et vous pourrez explorer toute la côte sans conduire. Saint-Tropez fait exception : la ville n'est pas desservie par le train, il faut une voiture, un bus ou un bateau."
      },
      {
        "q": "Quand les hôtels de la Côte d'Azur sont-ils les plus chers ?",
        "a": "Juillet et août sont la haute saison partout. Les prix grimpent aussi autour des grands événements : le Festival de Cannes en mai, le Grand Prix de Monaco à la fin du printemps et le Carnaval de Nice en février — pour ces dates, réservez des mois à l'avance ou logez dans une ville voisine. Le printemps et l'automne offrent des prix plus bas et un temps doux, et l'hiver est la période la moins chère, hors semaines de carnaval."
      },
      {
        "q": "Nice est-elle moins chère que Cannes ou Monaco ?",
        "a": "En général, oui. Nice offre de loin le plus grand choix d'hôtels et d'appartements, donc davantage d'options pour chaque budget. Monaco est l'endroit le plus cher de la côte, suivi de près par Cannes et Saint-Tropez en saison. Menton et Antibes offrent souvent un bon rapport qualité-prix, et loger dans une ville pour en visiter une autre en train est une façon courante d'économiser."
      },
      {
        "q": "Faut-il payer une taxe de séjour ?",
        "a": "Oui. Les communes françaises perçoivent une taxe de séjour par adulte et par nuit, fixée localement et plus élevée pour les hôtels mieux classés. Elle est souvent réglée à l'hôtel plutôt qu'incluse dans le prix affiché en ligne : vérifiez les conditions de réservation."
      },
      {
        "q": "Comment fonctionne la réservation depuis cette page ?",
        "a": "Nous ne vendons pas de chambres nous-mêmes. La carte et les boutons « Voir les hôtels » affichent les offres des principaux sites de réservation via notre partenaire Stay22 ; vous choisissez, réservez et payez sur le site de réservation, selon ses propres conditions. Nous pouvons percevoir une commission sur votre réservation, sans surcoût pour vous."
      }
    ]
  },
  "articlesHub": {
    "intro": [
      "Des articles sur la Côte d'Azur, de Saint-Tropez et Cannes à Nice, Monaco et Menton : quand partir et quels festivals ne pas manquer, que goûter et que boire, comment se passe une journée en yacht, où aller en excursion — pour préparer votre séjour, avec des liens vers ce qui se passe vraiment sur place."
    ],
    "cityGuidesHeading": "Guides des villes"
  },
  "cityClimate": {
    "heading": "Météo {{inCity}} mois par mois",
    "columns": {
      "month": "Mois",
      "high": "Jour °C",
      "low": "Nuit °C",
      "sea": "Mer °C",
      "rain": "Jours de pluie"
    },
    "note": "Pour la baignade et les sorties en bateau, visez juin à septembre, quand la mer dépasse 20 °C. Le printemps et l'automne, plus doux et plus calmes, se prêtent aux balades, aux excursions et aux visites de vignobles.",
    "source": "Températures moyennes de l'air le jour et la nuit et nombre de jours avec au moins 1 mm de pluie : normales climatiques Météo-France {{period}}, station {{station}}. Mer : moyenne mensuelle approximative sur la côte.",
    "stations": {
      "nice": "Nice-aéroport",
      "villefranche": "Nice-aéroport (la plus proche)",
      "cannes": "Cannes",
      "antibes": "Antibes",
      "monaco": "Monaco",
      "menton": "Monaco (la plus proche)",
      "sttropez": "Cogolin (la plus proche)"
    },
    "months": [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre"
    ],
    "inMonth": [
      "en janvier",
      "en février",
      "en mars",
      "en avril",
      "en mai",
      "en juin",
      "en juillet",
      "en août",
      "en septembre",
      "en octobre",
      "en novembre",
      "en décembre"
    ],
    "faq": {
      "byMonthQ": "Quel temps fait-il {{inCity}} selon les mois ?",
      "byMonthA": "L'hiver est doux, l'été chaud et sec. En journée, la moyenne va de {{coldHigh}} °C {{coldMonth}} à {{hotHigh}} °C {{hotMonth}}, et la nuit de {{coldLow}} °C à {{hotLow}} °C. C'est {{wetMonth}} qu'il pleut le plus souvent (environ {{wetDays}} jours de pluie), et {{dryMonth}} le moins.",
      "monthQ": "Quel temps fait-il {{inCity}} {{month}} ?",
      "monthA": "{{Month}}, il fait en moyenne {{high}} °C le jour et {{low}} °C la nuit, et la mer est autour de {{sea}} °C. Comptez environ {{rain}} jours de pluie dans le mois.",
      "swimQ": "Quand peut-on se baigner dans la mer {{inCity}} ?",
      "swimA": "De juin à septembre, la mer atteint 20 °C ou plus, environ 24 °C en août, et reste autour de 20 °C en octobre. En hiver, elle descend vers 13 °C : assez pour une courte baignade, mais froide pour la plupart des nageurs."
    }
  },
  "cityPages": {
    "nice": {
      "title": "Que faire à Nice",
      "metaDescription": "Concerts, expositions et festivals le long de la Promenade des Anglais : préparez votre séjour à Nice, la capitale de la Côte d'Azur.",
      "intro": [
        "Nice est le cœur battant de la Côte d'Azur, là où les Alpes plongent dans la Méditerranée le long de la célèbre Promenade des Anglais. Flânez le matin entre les façades pastel et les étals du marché du Vieux-Nice, puis profitez l'après-midi des plages de galets ou des collections du musée Matisse et du MAMAC.",
        "Au-delà des cartes postales, Nice propose toute l'année une programmation dense de concerts, d'expositions et de festivals, du carnaval de Nice en février aux scènes de jazz en plein air l'été. C'est aussi la meilleure base pour rayonner sur toute la Côte d'Azur : Cannes, Monaco et les villages perchés des Alpes-Maritimes sont à moins d'une heure."
      ]
    },
    "cannes": {
      "title": "Que faire à Cannes",
      "metaDescription": "Du tapis rouge de la Croisette aux ruelles du Suquet : découvrez les meilleurs événements, excursions et expériences à Cannes.",
      "intro": [
        "Cannes doit sa renommée à onze jours de mai, quand le cinéma mondial se donne rendez-vous au Palais des Festivals et que le tapis rouge s'étire sur la Croisette. Mais le glamour de la ville ne s'arrête pas là : les yachts mouillent toute l'année devant les hôtels Belle Époque, et le marché matinal du Suquet cède la place, l'après-midi, aux boutiques du centre.",
        "Hors saison du Festival, Cannes conserve une belle programmation d'expositions, de concerts et d'événements gastronomiques, ainsi que des liaisons faciles vers les îles de Lérins, juste au large. Une ville compacte, agréable à parcourir à pied, et l'une des mieux placées pour rayonner le long de la côte."
      ]
    },
    "monaco": {
      "title": "Que faire à Monaco",
      "metaDescription": "Soirées au casino, sensations du Grand Prix et faste Belle Époque : préparez votre visite de Monaco avec les meilleurs événements et excursions.",
      "intro": [
        "Avec à peine deux kilomètres carrés, Monaco concentre plus de faste au mètre carré que presque nulle part ailleurs. Le Casino de Monte-Carlo et le Palais princier ancrent une principauté bâtie sur des virages en épingle et des terrasses en surplomb de la mer — et le temps d'un week-end de mai, ses rues deviennent le circuit du Grand Prix, l'une des courses les plus exigeantes de la Formule 1.",
        "Quand les moteurs se taisent, Monaco offre des expositions de premier plan, l'aquarium du Musée océanographique et un port bordé de quelques-uns des plus grands yachts du monde. Une excursion facile depuis Nice ou Menton, et une étape naturelle sur la Côte d'Azur orientale."
      ]
    },
    "antibes": {
      "title": "Que faire à Antibes",
      "metaDescription": "L'ancien atelier de Picasso, les remparts médiévaux et le marché Provençal : découvrez les meilleurs événements et expériences à Antibes.",
      "intro": [
        "Antibes porte son histoire sur ses remparts — une vieille ville fortifiée par les Grecs puis par Vauban, enroulée autour d'un port qui abrita Picasso, dont certaines des œuvres les plus lumineuses se découvrent aujourd'hui au musée qui porte son nom. Le marché Provençal, ouvert tous les matins, compte parmi les plus beaux marchés alimentaires du littoral.",
        "Juste après le cap, Juan-les-Pins apporte une ambiance plus festive avec son festival de jazz et ses clubs de plage, tandis que le cap d'Antibes offre l'une des plus belles balades côtières de la Côte d'Azur. Entre les galeries de la vieille ville et les restaurants du port moderne, Antibes se savoure sans se presser."
      ]
    },
    "sttropez": {
      "title": "Que faire à Saint-Tropez",
      "metaDescription": "Du Vieux Port à la plage de Pampelonne : préparez votre séjour à Saint-Tropez avec les meilleurs événements, excursions en bateau et expériences.",
      "intro": [
        "Ancien village de pêcheurs, Saint-Tropez incarne depuis six décennies le glamour de la Côte d'Azur — son Vieux Port aligne toujours les mêmes façades pastel, aujourd'hui devant des yachts plutôt que des barques. La place des Lices accueille son marché et sa partie de pétanque permanente, tandis que la Citadelle, en surplomb, offre la plus belle vue sur la baie.",
        "Au sud du village, la longue plage de Pampelonne est le berceau des clubs de plage tropéziens, qui attirent toujours autant chaque été. Venez le temps d'une excursion en bateau depuis Sainte-Maxime ou Nice, ou restez assez longtemps pour voir le port au lever comme au coucher du soleil."
      ]
    },
    "menton": {
      "title": "Que faire à Menton",
      "metaDescription": "Citronniers, lumière italienne et Fête du Citron : découvrez les événements, excursions et expériences de Menton, la perle discrète de la Côte d'Azur.",
      "intro": [
        "Adossée à la frontière italienne, Menton troque l'agitation de la Côte d'Azur contre une douceur pastel — une vieille ville aux ruelles étroites et pentues qui grimpent vers une basilique baroque, et un front de mer bordé des jardins d'agrumes qui valent à la ville son surnom de « perle de la France ».",
        "Chaque février, la célèbre Fête du Citron transforme les jardins du bord de mer en sculptures géantes entièrement composées d'agrumes. Le reste de l'année, ses jardins, ses petits musées et ses sentiers de randonnée en font l'une des bases les plus paisibles de la Côte d'Azur — à deux pas de Monaco et de la frontière italienne."
      ]
    },
    "villefranche": {
      "title": "Que faire à Villefranche-sur-Mer",
      "metaDescription": "L'une des plus profondes rades naturelles de Méditerranée, une chapelle décorée par Cocteau et une vieille ville colorée : découvrez Villefranche-sur-Mer.",
      "intro": [
        "Villefranche-sur-Mer s'étend sur l'une des rades naturelles les plus profondes de Méditerranée, ce qui explique pourquoi les paquebots de croisière y mouillent aujourd'hui à la place des barques de pêcheurs. Sa vieille ville forme un dédale serré d'escaliers couverts et de façades pastel qui plongent jusqu'à l'eau, sous le regard de la citadelle Saint-Elme, du XVIe siècle.",
        "Ne manquez pas la petite chapelle Saint-Pierre, décorée à l'intérieur par Jean Cocteau, ni le sentier côtier du cap Ferrat, juste à côté. C'est l'une des plus petites villes de cette liste, mais sa plage et ses restaurants au bord du port en font une base simple et tranquille pour explorer toute la baie."
      ]
    }
  },
  "features": {
    "notifications": {
      "title": "Notifications",
      "desc": "Soyez informé des événements qui vous intéressent"
    },
    "favorites": {
      "title": "Favoris",
      "desc": "Enregistrez des événements et créez votre calendrier personnel"
    },
    "map": {
      "title": "Carte des événements",
      "desc": "Trouvez des événements près de chez vous sur la carte interactive"
    },
    "tickets": {
      "title": "Acheter des billets",
      "desc": "Achetez des billets directement auprès de partenaires de confiance"
    }
  },
  "wineTours": {
    "region": {
      "title": "Dégustations de vin et visites de vignobles sur la Côte d'Azur",
      "seoTitle": "Dégustation de vin et vignobles sur la Côte d'Azur",
      "metaDescription": "Excursions œnologiques les mieux notées au départ de Nice, Cannes, Saint-Tropez, Antibes et Monaco : rosés de Provence, vignobles de Bellet et de Bandol.",
      "intro": [
        "La Côte d'Azur est aux portes de la Provence, première région productrice de vin rosé au monde. À moins d'une heure du littoral, on déguste déjà dans les domaines des Côtes de Provence — et Nice possède même sa propre petite appellation, Bellet, sur les collines qui dominent la ville.",
        "Voici les excursions et dégustations de vin les mieux notées au départ des principales villes de la Riviera : des ateliers de dégustation de deux heures aux journées privées avec chauffeur, pour que personne n'ait à conduire après la dégustation. Chaque excursion se réserve en toute sécurité sur Viator, où figurent les disponibilités, le point de prise en charge et les conditions d'annulation."
      ],
      "listHeading": "Les excursions œnologiques les mieux notées de la Riviera",
      "privateHeading": "Excursions œnologiques privées sur la Côte d'Azur",
      "sections": [
        {
          "heading": "Les vignobles autour de la Riviera",
          "paragraphs": [
            "Bellet est l'une des plus petites appellations de France : quelques domaines familiaux sur les collines au-dessus de Nice, face à la vallée du Var. Ses blancs sont surtout issus du rolle (vermentino), ses rouges et rosés de cépages locaux rares comme le braquet et la folle noire, presque introuvables ailleurs.",
            "Les Côtes de Provence forment la plus grande appellation de Provence, et presque tout y est rosé — sec et pâle, à base de grenache, cinsault et syrah. Le vignoble s'étend de la presqu'île de Saint-Tropez (Ramatuelle, Gassin, La Croix-Valmer) jusqu'à l'intérieur du Var, vers Les Arcs-sur-Argens, Lorgues et La Motte. Plus à l'ouest, près de Toulon, Bandol est réputé pour ses rouges profonds de mourvèdre, faits pour vieillir."
          ]
        },
        {
          "heading": "Comment se déroule une excursion œnologique",
          "paragraphs": [
            "La formule la plus courte est l'atelier de dégustation en ville : en deux heures environ, un sommelier explique comment déguster et fait goûter une sélection de vins de Provence. Une demi-journée visite généralement un ou deux domaines — au départ de Nice, le plus souvent à Bellet. Une journée complète enchaîne deux ou trois domaines, un déjeuner en Provence et souvent un arrêt dans un village perché comme Saint-Paul-de-Vence.",
            "Au domaine, on parcourt en général les vignes et le chai avant de déguster plusieurs vins, parfois avec du fromage ou des spécialités locales — et l'on peut acheter sur place les bouteilles qui ont plu. Beaucoup de petits domaines ne reçoivent que sur rendez-vous : une excursion au programme fixé reste le moyen le plus simple d'y accéder."
          ]
        }
      ]
    },
    "cities": {
      "nice": {
        "title": "Dégustations de vin et vignobles au départ de Nice",
        "seoTitle": "Dégustation de vin à Nice : Bellet et Provence",
        "metaDescription": "Excursions œnologiques au départ de Nice : vignobles de Bellet au-dessus de la ville, rosés des Côtes de Provence, journées privées avec prise en charge.",
        "intro": [
          "Nice est l'une des rares villes françaises à abriter une appellation viticole sur son propre territoire : l'AOC Bellet, quelques domaines familiaux sur les collines à l'ouest de la ville, à une vingtaine de minutes du centre. Ses blancs sont issus principalement du rolle (vermentino), aux côtés de cépages locaux rares comme le braquet et la folle noire.",
          "Pour une journée complète, les excursions au départ de Nice rejoignent aussi le Var et les domaines de rosé des Côtes de Provence, souvent avec un village perché comme Saint-Paul-de-Vence. La plupart incluent la prise en charge à l'hôtel : vous dégustez l'esprit tranquille."
        ],
        "listHeading": "Les excursions œnologiques les mieux notées au départ de Nice",
        "privateHeading": "Excursions œnologiques privées au départ de Nice"
      },
      "cannes": {
        "title": "Dégustations de vin et vignobles au départ de Cannes",
        "seoTitle": "Dégustation de vin à Cannes et en Provence",
        "metaDescription": "Excursions et dégustations de vin au départ de Cannes : domaines de rosé des Côtes de Provence, journées privées avec chauffeur, Grasse et villages perchés.",
        "intro": [
          "Depuis Cannes, le pays du rosé des Côtes de Provence est à environ une heure de route vers l'ouest, autour des Arcs-sur-Argens, de Lorgues ou de La Motte. Les excursions œnologiques au départ de Cannes visitent généralement deux ou trois domaines — souvent un château — avec une dégustation commentée de rosés, de blancs et de rouges.",
          "Les formules plus courtes associent une dégustation locale aux parfumeries de Grasse et aux villages perchés de l'arrière-pays. Et juste en face, les moines de l'abbaye de Lérins, sur l'île Saint-Honorat, cultivent toujours leur propre vignoble — à quelques minutes de bateau du Vieux-Port."
        ],
        "listHeading": "Les excursions œnologiques les mieux notées au départ de Cannes",
        "privateHeading": "Excursions œnologiques privées au départ de Cannes"
      },
      "sttropez": {
        "title": "Dégustations de vin et vignobles à Saint-Tropez",
        "seoTitle": "Dégustation de vin à Saint-Tropez : domaines de rosé",
        "metaDescription": "Excursions œnologiques à Saint-Tropez : domaines de rosé des Côtes de Provence à Ramatuelle, Gassin et La Croix-Valmer, en privé ou en petit groupe.",
        "intro": [
          "Saint-Tropez est au cœur du pays du rosé. Les vignes couvrent la presqu'île autour de Ramatuelle, Gassin et La Croix-Valmer, et plusieurs des domaines de rosé les plus connus de Provence sont à moins de 20 minutes du port.",
          "Au choix : excursions partagées en petit groupe, visites privées des domaines de la presqu'île ou dîner au milieu des vignes. L'été est la haute saison ; de fin août à septembre, vous verrez peut-être les vendanges."
        ],
        "listHeading": "Les excursions œnologiques les mieux notées à Saint-Tropez",
        "privateHeading": "Excursions œnologiques privées à Saint-Tropez"
      },
      "antibes": {
        "title": "Dégustations de vin et vignobles au départ d'Antibes",
        "seoTitle": "Dégustation de vin au départ d'Antibes",
        "metaDescription": "Excursions œnologiques au départ d'Antibes et Juan-les-Pins : journées privées en Provence, domaines de rosé, dégustations et produits du terroir.",
        "intro": [
          "À mi-chemin entre Nice et Cannes, Antibes est une base pratique pour une journée œnologique : les vignobles de Bellet, au-dessus de Nice, sont à une trentaine de minutes, et les domaines de rosé des Côtes de Provence à environ une heure à l'ouest.",
          "Les excursions au départ d'Antibes vont de la balade au marché provençal avec dégustation à la journée privée dans les vignobles du Var, avec chauffeur-guide et prise en charge à Antibes ou à Juan-les-Pins."
        ],
        "listHeading": "Les excursions œnologiques les mieux notées au départ d'Antibes",
        "privateHeading": "Excursions œnologiques privées au départ d'Antibes"
      },
      "menton": {
        "title": "Dégustations de vin et excursions œnologiques à Menton",
        "seoTitle": "Dégustation de vin à Menton",
        "metaDescription": "Dégustations de vin à Menton : ateliers en petit groupe, vignobles de Bellet près de Nice et vins de Ligurie juste après la frontière italienne.",
        "intro": [
          "Menton, à la frontière italienne, est surtout connue pour ses citrons — mais c'est aussi une bonne base pour découvrir le vin. En ville, des ateliers de dégustation en petit groupe font découvrir les vins de Provence et de la Riviera italienne voisine sans quitter la vieille ville.",
          "Un peu plus loin, les vignobles de Bellet, au-dessus de Nice, sont à environ 45 minutes, et juste après la frontière, en Ligurie, le rouge Rossese di Dolceacqua est produit dans les collines derrière Vintimille."
        ],
        "listHeading": "Les dégustations et excursions œnologiques les mieux notées à Menton",
        "privateHeading": "Excursions œnologiques privées au départ de Menton"
      },
      "monaco": {
        "title": "Excursions œnologiques au départ de Monaco",
        "seoTitle": "Excursions œnologiques au départ de Monaco",
        "metaDescription": "Excursions œnologiques au départ de Monaco : journées privées dans les domaines de rosé des Côtes de Provence, vignobles de Bellet et de Ligurie.",
        "intro": [
          "Monaco n'a pas d'appellation viticole, mais la Principauté est un point de départ confortable pour une journée autour du vin : l'appellation Bellet, au-dessus de Nice, est à une quarantaine de minutes, et la frontière italienne — avec les vignobles ligures de Dolceacqua au-delà — encore plus près.",
          "Pour vivre la Provence viticole, les excursions privées au départ de Monaco rejoignent à l'ouest les domaines de rosé des Côtes de Provence, généralement avec prise en charge à votre hôtel ou à votre bateau et un chauffeur-guide pour la journée."
        ],
        "listHeading": "Les excursions œnologiques les mieux notées au départ de Monaco",
        "privateHeading": "Excursions œnologiques privées au départ de Monaco"
      },
      "villefranche": {
        "title": "Excursions œnologiques au départ de Villefranche-sur-Mer",
        "seoTitle": "Dégustation de vin au départ de Villefranche-sur-Mer",
        "metaDescription": "Excursions œnologiques au départ de Villefranche-sur-Mer, dont des demi-journées compatibles avec une escale de croisière : Bellet et rosés de Provence.",
        "intro": [
          "Villefranche-sur-Mer est l'un des mouillages de croisière les plus fréquentés de Méditerranée, et une dégustation de vin est l'une des excursions les plus simples depuis le port : les vignobles de Bellet, au-dessus de Nice, sont à une trentaine de minutes, et une demi-journée s'intègre facilement dans une escale.",
          "Avec une journée entière, les excursions continuent vers l'ouest jusqu'aux domaines de rosé des Côtes de Provence. Si vous arrivez en bateau, vérifiez le point de prise en charge et l'heure de retour sur chaque offre."
        ],
        "listHeading": "Les excursions œnologiques les mieux notées au départ de Villefranche-sur-Mer",
        "privateHeading": "Excursions œnologiques privées au départ de Villefranche-sur-Mer"
      }
    },
    "faq": [
      {
        "q": "Quelles régions viticoles visiter depuis la Côte d'Azur ?",
        "a": "La plus proche est Bellet, une petite appellation sur les collines à l'ouest de Nice. À environ une heure à l'ouest de Cannes s'étendent les domaines de rosé des Côtes de Provence, autour des Arcs-sur-Argens, de Lorgues et de la presqu'île de Saint-Tropez. Certaines journées vont plus loin, jusqu'à Bandol près de Toulon, réputé pour ses rouges à base de mourvèdre."
      },
      {
        "q": "Quels vins vais-je déguster ?",
        "a": "Surtout du rosé : c'est de loin la couleur dominante des Côtes de Provence. Mais aussi des blancs frais issus du rolle (vermentino) et des rouges structurés à Bandol et à Bellet. Une visite de domaine comprend en général la dégustation de trois à cinq vins."
      },
      {
        "q": "Combien coûte une excursion œnologique sur la Côte d'Azur ?",
        "a": "Les formules les plus abordables sont les ateliers de dégustation et les excursions partagées en petit groupe, au prix par personne. Les journées privées avec chauffeur-guide coûtent nettement plus cher et sont souvent facturées par groupe plutôt que par personne. Chaque excursion affiche son prix de départ actuel."
      },
      {
        "q": "Une excursion œnologique privée, ça vaut le coup ?",
        "a": "En couple, une excursion partagée en petit groupe reste généralement l'option la moins chère. Une excursion privée se justifie en famille ou entre amis, pour une occasion spéciale, ou si vous voulez choisir vous-même les domaines : un chauffeur-guide rien que pour vous, une prise en charge sur votre lieu de séjour et des horaires souples. Les excursions privées sont présentées à part sur chaque page."
      },
      {
        "q": "Faut-il une voiture ?",
        "a": "Non. La plupart des excursions incluent le transport et la prise en charge à votre hôtel, au port ou à un point de rendez-vous central, pour que tout le monde puisse déguster. En France, le taux d'alcool maximal au volant est de 0,5 g/l : une excursion avec chauffeur est le choix le plus raisonnable."
      },
      {
        "q": "Quelle est la meilleure période pour une excursion œnologique ?",
        "a": "Les domaines accueillent les visiteurs toute l'année, mais c'est du printemps à l'automne que la saison est la plus animée, avec les vendanges de fin août à septembre. Beaucoup de petits domaines ferment le dimanche et certains réduisent leurs horaires en hiver : vérifiez les disponibilités de chaque excursion."
      },
      {
        "q": "Comment réserver, et peut-on annuler ?",
        "a": "Les excursions se réservent sur Viator, qui gère le paiement et la confirmation. Beaucoup offrent l'annulation gratuite jusqu'à 24 heures avant le départ — vérifiez les conditions de chaque offre avant de réserver."
      }
    ],
    "citiesHeading": "Par ville de départ",
    "cityLinksHeading": "Excursions œnologiques par ville",
    "groupHeading": "Excursions en groupe et dégustations",
    "privateIntro": "Lors d'une excursion privée, la voiture, le chauffeur-guide et le programme sont pour vous seuls : la plupart viennent vous chercher à votre hôtel, votre villa ou au port de croisière, et vous choisissez les domaines et le rythme. Le prix est souvent fixé par groupe plutôt que par personne — vérifiez sur chaque fiche —, ce qui les rend surtout intéressantes en famille ou entre amis.",
    "compare": {
      "note": "Classement selon la note et le nombre d'avis. Prix : tarif de départ actuel sur Viator.",
      "tour": "Excursion",
      "from": "Départ",
      "duration": "Durée",
      "format": "Formule",
      "rating": "Avis",
      "price": "Prix dès",
      "private": "Privée",
      "group": "En groupe"
    },
    "allCities": "Toute la Riviera",
    "stats_one": "{{count}} excursion œnologique · à partir de {{price}}",
    "stats_other": "{{count}} excursions œnologiques · à partir de {{price}}",
    "faqHeading": "Excursions œnologiques : questions fréquentes",
    "loading": "Chargement des excursions…",
    "empty": "Aucune excursion œnologique pour le moment.",
    "allTours": "Voir toutes les excursions et activités"
  },
  "boatsHub": {
    "intro": [
      "Bateaux à moteur, semi-rigides, yachts à moteur, voiliers, catamarans et bateaux sans permis à louer dans les ports de la Côte d'Azur, de Saint-Tropez et Cannes à Antibes, Nice, Monaco et Menton. Location à la demi-journée, à la journée ou plus, avec skipper ou en autonomie : chaque annonce indique le type de bateau, le port, le tarif à la journée et un lien pour réserver sur Click&Boat."
    ],
    "sections": [
      {
        "heading": "Où aller en bateau",
        "paragraphs": [
          "Depuis Cannes, les îles de Lérins — Sainte-Marguerite et Saint-Honorat — sont à quelques minutes, et à l'ouest les roches rouges de l'Esterel cachent des criques tranquilles. Depuis Antibes et Juan-les-Pins, on fait le tour du cap d'Antibes ; depuis Nice et Villefranche-sur-Mer, la rade abritée de Villefranche et les criques du cap Ferrat. Depuis Saint-Tropez, la sortie classique mène à la plage de Pampelonne et dans le golfe, et depuis Monaco, le long de la côte vers le cap Martin et Menton."
        ]
      },
      {
        "heading": "Quel bateau choisir",
        "paragraphs": [
          "Les bateaux sans permis ont un petit moteur et conviennent aux sorties courtes et faciles près du rivage. Les semi-rigides sont rapides et maniables — le choix habituel pour rejoindre les îles et les criques. Le bateau à moteur est l'option polyvalente pour une journée en mer en famille, tandis que les yachts à moteur se louent surtout avec skipper, pour les groupes et les occasions. Voiliers et catamarans sont faits pour naviguer à la voile ; le catamaran, stable et spacieux, est apprécié pour les longues journées et les groupes."
        ]
      },
      {
        "heading": "Bon à savoir avant de partir",
        "paragraphs": [
          "En France, piloter un bateau de plus de 6 CV exige un permis bateau (le permis côtier pour la navigation près des côtes) ; sans permis, choisissez un bateau sans permis ou un skipper. Dans la bande des 300 mètres, la vitesse est limitée à 5 nœuds, et les zones de baignade balisées sont interdites aux bateaux. La mer est généralement plus calme le matin : prévoyez les traversées tôt et vérifiez la météo avec le propriétaire."
        ]
      }
    ],
    "citiesHeading": "Location de bateau par ville"
  },
  "boatRental": {
    "cities": {
      "nice": {
        "title": "Location de bateau à Nice",
        "seoTitle": "Location de bateau à Nice — avec ou sans permis",
        "inCity": "à Nice"
      },
      "cannes": {
        "title": "Location de bateau à Cannes",
        "seoTitle": "Location de bateau à Cannes — yachts et semi-rigides",
        "inCity": "à Cannes"
      },
      "antibes": {
        "title": "Location de bateau à Antibes",
        "seoTitle": "Location de bateau à Antibes et Juan-les-Pins",
        "inCity": "à Antibes"
      },
      "villefranche": {
        "title": "Location de bateau à Villefranche-sur-Mer",
        "seoTitle": "Location de bateau à Villefranche-sur-Mer",
        "inCity": "à Villefranche-sur-Mer"
      },
      "monaco": {
        "title": "Location de bateau à Monaco",
        "seoTitle": "Location de bateau et de yacht à Monaco",
        "inCity": "à Monaco"
      },
      "menton": {
        "title": "Location de bateau à Menton",
        "seoTitle": "Location de bateau à Menton — avec ou sans skipper",
        "inCity": "à Menton"
      },
      "sttropez": {
        "title": "Location de bateau à Saint-Tropez",
        "seoTitle": "Location de bateau à Saint-Tropez — yachts et semi-rigides",
        "inCity": "à Saint-Tropez"
      }
    },
    "metaDescription_one": "Louez un bateau {{inCity}} : {{count}} bateau dès {{price}}/jour, avec ou sans skipper. Comparez et réservez sur Click&Boat.",
    "metaDescription_other": "Louez un bateau {{inCity}} : {{count}} bateaux dès {{price}}/jour — bateaux à moteur, semi-rigides, yachts et catamarans, avec ou sans skipper. Réservez sur Click&Boat.",
    "stats_one": "{{count}} bateau · dès {{price}}/jour",
    "stats_other": "{{count}} bateaux · dès {{price}}/jour",
    "ratingStat": "note moyenne {{rating}}/5",
    "typesHeading": "Types de bateaux et prix",
    "typeRow_one": "{{count}} bateau · dès {{price}}",
    "typeRow_other": "{{count}} bateaux · dès {{price}} · généralement {{median}}/jour",
    "portsHeading": "Ports de départ",
    "topHeading": "Les bateaux les mieux notés {{inCity}}",
    "allHeading": "Tous les bateaux à louer {{inCity}}",
    "citiesHeading": "Location de bateau dans d'autres villes de la Riviera",
    "allBoats": "Toutes les locations de yachts et bateaux sur la Riviera",
    "faqHeading": "Louer un bateau {{inCity}} : questions fréquentes",
    "listSeparator": ", ",
    "loading": "Chargement des bateaux…",
    "empty": "Aucun bateau trouvé.",
    "typePlural": {
      "Motorboat": "bateaux à moteur",
      "Sailboat": "voiliers",
      "Catamaran": "catamarans",
      "RIB": "semi-rigides",
      "Motor yacht": "yachts à moteur",
      "Houseboat": "péniches",
      "Boat without licence": "bateaux sans permis",
      "Jet ski": "jet-skis",
      "Sailing yacht": "yachts à voile",
      "other": "autres bateaux"
    },
    "faq": {
      "priceQ": "Combien coûte la location d’un bateau {{inCity}} ?",
      "priceA": "Les tarifs à la journée {{inCity}} commencent à {{min}}, et la moitié des bateaux proposés coûtent {{median}} par jour ou moins. Par type : {{list}}. Le carburant, le skipper et les options sont généralement facturés en plus — chaque annonce sur Click&Boat précise ce qui est inclus.",
      "typePrice": "{{type}} dès {{price}}",
      "licenceQ": "Peut-on louer un bateau sans permis {{inCity}} ?",
      "licenceYesA_one": "Oui — {{count}} bateau sans permis est proposé {{inCity}}, dès {{price}} par jour : un petit bateau peu motorisé que l’on peut piloter sans permis. Tous les autres bateaux peuvent être loués avec un skipper, et aucun permis n’est alors nécessaire.",
      "licenceYesA_other": "Oui — {{count}} bateaux sans permis sont proposés {{inCity}}, dès {{price}} par jour : de petits bateaux peu motorisés que l’on peut piloter sans permis. Tous les autres bateaux peuvent être loués avec un skipper, et aucun permis n’est alors nécessaire.",
      "licenceNoA": "Aucun bateau sans permis n’est proposé {{inCity}} pour le moment, mais de nombreux bateaux peuvent être loués avec un skipper — aucun permis n’est alors nécessaire. Pour piloter vous-même un bateau à moteur de plus de 6 ch, il faut le permis côtier.",
      "portsQ": "D’où partent les bateaux de location {{inCity}} ?",
      "portsA": "Les bateaux proposés {{inCity}} partent de : {{list}}. Le point de rendez-vous exact figure sur chaque annonce.",
      "typesQ": "Quels types de bateaux peut-on louer {{inCity}} ?",
      "typesA": "La flotte {{inCity}} comprend actuellement : {{list}}. Les bateaux à moteur et les semi-rigides conviennent à une demi-journée ou une journée le long de la côte, seul ou avec un skipper ; les catamarans et les yachts à moteur se louent généralement avec skipper, pour les groupes."
    },
    "detailLink": "Louer un bateau {{inCity}} : prix, permis et ports de départ",
    "showAllType": "Afficher les {{count}} {{type}}",
    "showFewer": "Afficher moins",
    "typeChipsHeading": "Types de bateaux {{inCity}}",
    "typeMeta": "{{countText}} à louer {{inCity}} dès {{price}}/jour, généralement {{median}}. Comparez les tarifs et les ports de départ, puis réservez sur Click&Boat.",
    "typeStats": "{{countText}} · dès {{price}}/jour · généralement {{median}}/jour",
    "typePricesHeading": "Tarifs à la journée",
    "typeTopHeading": "Les {{plural}} les mieux notés {{inCity}}",
    "typeAllHeading": "Tous les {{plural}} à louer {{inCity}}",
    "typeOtherTypesHeading": "Autres bateaux {{inCity}}",
    "typeOtherCitiesHeading": "{{pluralCap}} dans d'autres villes de la Riviera",
    "typeFaqHeading": "{{title}} : questions fréquentes",
    "typePriceA": "Les tarifs des {{plural}} {{inCity}} commencent à {{min}} par jour, et la moitié coûtent {{median}} ou moins. Par prix : {{bands}}. Le carburant, le skipper et les options sont généralement facturés en plus — chaque annonce sur Click&Boat précise ce qui est inclus.",
    "typePortsQ": "D'où partent les {{plural}} {{inCity}} ?",
    "typePortsA": "Les {{plural}} proposés {{inCity}} partent de {{list}}. Le point de rendez-vous exact figure sur chaque annonce.",
    "typeDetailLink": "{{title}} : prix et ports de départ",
    "typePages": {
      "motorboat": {
        "title": "Location de bateau à moteur {{inCity}}",
        "seoTitle": "Location bateau à moteur {{inCity}} — avec ou sans skipper",
        "plural": "bateaux à moteur",
        "count_one": "{{count}} bateau à moteur",
        "count_other": "{{count}} bateaux à moteur",
        "intro": "Le bateau à moteur est la façon la plus simple de profiter de la mer {{inCity}} : facile à manœuvrer, assez rapide pour rejoindre les criques et les îles voisines, et disponible avec ou sans skipper. Voici tous les bateaux à moteur proposés {{inCity}} sur Click&Boat, avec leurs tarifs à la journée et leurs ports de départ.",
        "priceQ": "Combien coûte la location d'un bateau à moteur {{inCity}} ?",
        "licenceQ": "Faut-il un permis pour louer un bateau à moteur {{inCity}} ?",
        "licenceA": "Pour piloter vous-même, le permis côtier est obligatoire au-delà de 6 CV, ce qui concerne presque tous les bateaux ici. Sans permis, réservez le bateau avec un skipper — de nombreux propriétaires le proposent — ou choisissez un bateau sans permis."
      },
      "rib": {
        "title": "Location de semi-rigide {{inCity}}",
        "seoTitle": "Location semi-rigide {{inCity}} — à la journée",
        "plural": "semi-rigides",
        "count_one": "{{count}} semi-rigide",
        "count_other": "{{count}} semi-rigides",
        "intro": "Léger, rapide et stable, le semi-rigide est le bateau idéal pour une journée de baignade de crique en crique {{inCity}}. Voici tous les semi-rigides proposés {{inCity}} sur Click&Boat, avec leurs prix et leurs ports de départ.",
        "priceQ": "Combien coûte la location d'un semi-rigide {{inCity}} ?",
        "licenceQ": "Faut-il un permis pour louer un semi-rigide {{inCity}} ?",
        "licenceA": "La plupart des semi-rigides ont un moteur de bien plus de 6 CV : il faut donc le permis côtier pour les piloter soi-même. Sans permis, louez un semi-rigide avec skipper."
      },
      "yacht": {
        "title": "Location de yacht {{inCity}}",
        "seoTitle": "Location yacht {{inCity}} — à la journée avec skipper",
        "plural": "yachts",
        "count_one": "{{count}} yacht",
        "count_other": "{{count}} yachts",
        "intro": "Un yacht à moteur ou à voile, c'est la journée en mer {{inCity}} tout confort : pont ombragé, cabine et de la place pour un groupe, le plus souvent avec un skipper professionnel à bord. Voici tous les yachts proposés {{inCity}} sur Click&Boat, avec leurs tarifs à la journée et leurs ports de départ.",
        "priceQ": "Combien coûte la location d'un yacht à la journée {{inCity}} ?",
        "licenceQ": "Faut-il un permis pour louer un yacht {{inCity}} ?",
        "licenceA": "En général non : les yachts se louent presque toujours avec skipper ou équipage, qui s'occupent du bateau. Le carburant, le skipper et les options sont souvent facturés en plus du tarif journalier — chaque annonce précise ce qui est inclus."
      },
      "sailboat": {
        "title": "Location de voilier {{inCity}}",
        "seoTitle": "Location voilier {{inCity}} — avec ou sans skipper",
        "plural": "voiliers",
        "count_one": "{{count}} voilier",
        "count_other": "{{count}} voiliers",
        "intro": "Louer un voilier {{inCity}}, c'est une journée paisible à la voile le long de la côte — avec un skipper pour simplement en profiter, ou seul si vous êtes un navigateur expérimenté. Voici tous les voiliers proposés {{inCity}} sur Click&Boat, avec leurs prix et leurs ports de départ.",
        "priceQ": "Combien coûte la location d'un voilier {{inCity}} ?",
        "licenceQ": "Faut-il un permis pour louer un voilier {{inCity}} ?",
        "licenceA": "Avec un skipper, aucun permis n'est nécessaire. Pour naviguer seul, les propriétaires demandent une expérience de la voile, et le permis côtier est obligatoire pour utiliser un moteur de plus de 6 CV."
      },
      "catamaran": {
        "title": "Location de catamaran {{inCity}}",
        "seoTitle": "Location catamaran {{inCity}} — à la journée avec skipper",
        "plural": "catamarans",
        "count_one": "{{count}} catamaran",
        "count_other": "{{count}} catamarans",
        "intro": "Stable, spacieux et idéal en groupe, le catamaran offre deux coques, un grand pont et des trampolines pour bronzer entre deux baignades. La plupart des catamarans {{inCity}} se louent à la journée avec skipper. Les voici tous sur Click&Boat, avec leurs tarifs et leurs ports de départ.",
        "priceQ": "Combien coûte la location d'un catamaran {{inCity}} ?",
        "licenceQ": "Faut-il un permis pour louer un catamaran {{inCity}} ?",
        "licenceA": "Pas si vous le réservez avec skipper, ce qui est le cas de la plupart des catamarans. Pour le piloter vous-même, le propriétaire demandera une expérience de navigation, et le permis côtier est obligatoire au-delà de 6 CV."
      },
      "no-licence": {
        "title": "Location de bateau sans permis {{inCity}}",
        "seoTitle": "Location bateau sans permis {{inCity}}",
        "plural": "bateaux sans permis",
        "count_one": "{{count}} bateau sans permis",
        "count_other": "{{count}} bateaux sans permis",
        "intro": "Pas de permis bateau ? Les bateaux sans permis ont un moteur de 6 CV maximum : en France, tout le monde peut les piloter après une courte prise en main avec le propriétaire. Moins rapides que les autres, ils restent près de la côte — parfaits pour quelques heures de baignade {{inCity}}. Les voici tous sur Click&Boat, avec leurs prix et leurs ports de départ.",
        "priceQ": "Combien coûte la location d'un bateau sans permis {{inCity}} ?",
        "licenceQ": "Peut-on vraiment piloter ces bateaux sans permis {{inCity}} ?",
        "licenceA": "Oui. En France, un bateau dont le moteur ne dépasse pas 6 CV (4,5 kW) se pilote sans permis ; le propriétaire vous explique tout avant le départ. Tout autre bateau peut aussi se louer avec un skipper, et aucun permis n'est alors nécessaire."
      }
    }
  },
  "eventsHub": {
    "intro": [
      "Concerts, théâtre, humour, spectacles et festivals à venir sur la Côte d'Azur, réunis en un seul endroit — de Nice et Cannes à Monaco, Antibes et Menton. L'agenda est mis à jour chaque jour : pour chaque événement, les dates, la salle, le prix de départ et un lien vers la billetterie officielle."
    ],
    "sections": [
      {
        "heading": "Les grands rendez-vous de l'année",
        "paragraphs": [
          "L'année s'ouvre avec le Festival International du Cirque de Monte-Carlo en janvier. En février ont lieu le Carnaval de Nice et la Fête du Citron à Menton, les deux grandes fêtes d'hiver du Sud de la France. En mai, Cannes accueille son festival du film, et en mai ou juin Monaco organise son Grand Prix de Formule 1.",
          "L'été, la Riviera vit en plein air : Nice Jazz Festival et Jazz à Juan à Juan-les-Pins (Antibes) en juillet, et le concours international de feux d'artifice au-dessus de la baie de Cannes les soirs d'été. De l'automne au printemps, c'est la saison des théâtres, des opéras et des salles de concert — celle où l'agenda compte le plus de pièces, de spectacles d'humour, de ballets et de musique classique."
        ]
      },
      {
        "heading": "Où ont lieu les concerts et les spectacles",
        "paragraphs": [
          "Les grandes tournées passent par l'arène du Palais Nikaïa à Nice et le Palais des Festivals à Cannes. À Monaco, les scènes principales sont l'Opéra de Monte-Carlo et le Grimaldi Forum ; à Nice, l'Opéra de Nice et le Théâtre National de Nice. L'humour, les pièces intimistes et les concerts se jouent dans les théâtres, clubs et casinos de chaque ville de la côte — la salle exacte figure sur la page de l'événement."
        ]
      },
      {
        "heading": "Comment acheter ses billets",
        "paragraphs": [
          "Ouvrez un événement pour voir toutes ses dates, la salle et le prix de départ. Quand un spectacle se joue plusieurs fois, toutes les dates sont réunies sur une seule page, chacune avec son bouton Billets. L'achat se fait sur le site du vendeur officiel, où l'on choisit ses places et paie — au prix du vendeur."
        ]
      }
    ],
    "citiesHeading": "Agenda par ville",
    "faqHeading": "Agenda de la Côte d'Azur : questions fréquentes",
    "faq": [
      {
        "q": "Que faire le soir sur la Côte d'Azur ?",
        "a": "L'agenda réunit concerts, théâtre, humour, spectacles et festivals à Nice, Cannes, Monaco, Antibes, Menton et dans les autres villes de la Riviera. Chaque ville a aussi sa propre page avec tous les événements à venir, classés par catégorie."
      },
      {
        "q": "Quand y a-t-il le plus d'événements ?",
        "a": "La saison de théâtre et de concerts va de l'automne au printemps, quand opéras, théâtres et salles de concert sont ouverts. L'été est la saison des festivals et des concerts en plein air, et janvier–février celle du festival du cirque de Monaco, du Carnaval de Nice et de la Fête du Citron à Menton."
      },
      {
        "q": "Comment acheter des billets ?",
        "a": "Ouvrez un événement et cliquez sur Obtenir des billets, ou sur le bouton Billets à côté de la date choisie — vous arrivez sur le site du vendeur officiel, où vous choisissez vos places et payez."
      },
      {
        "q": "L'agenda est-il à jour ?",
        "a": "Il est mis à jour chaque jour : les nouveaux événements apparaissent dès l’ouverture de la billetterie, et les événements passés disparaissent des listes."
      }
    ]
  },
  "cityEvents": {
    "cities": {
      "nice": {
        "title": "Événements à Nice",
        "seoTitle": "Agenda de Nice — concerts, théâtre et spectacles",
        "intro": [
          "Nice a l'agenda culturel le plus chargé de la Côte d'Azur. Le Palais Nikaïa, la grande salle à l'ouest de la ville, accueille les tournées de concerts et de spectacles, tandis que l'Opéra de Nice, le Théâtre National de Nice et des scènes plus intimes comme le Théâtre Lino Ventura ou le Théâtre de la Cité proposent théâtre, humour et musique classique de l'automne au printemps.",
          "Les temps forts de l'année sont le Carnaval en février et le Nice Jazz Festival en juillet. Voici tous les événements à venir que nous référençons à Nice — les prochains d'abord, puis la liste complète par catégorie — avec leur date, leur salle et un lien pour réserver."
        ]
      },
      "cannes": {
        "title": "Événements à Cannes",
        "seoTitle": "Agenda de Cannes — concerts, spectacles et festivals",
        "intro": [
          "En dehors du Festival du film, l'essentiel de la vie culturelle cannoise se joue au Palais des Festivals, sur la Croisette : le Théâtre Debussy et le Grand Auditorium y programment théâtre, concerts, ballet et humour tout au long de la saison. Le Théâtre Croisette, le Théâtre Alexandre III et l'Espace Miramar complètent l'offre avec des productions plus intimes.",
          "L'été, la baie devient la scène du Festival d'Art Pyrotechnique, le concours international de feux d'artifice. Voici tous les événements à venir que nous référençons à Cannes, avec dates, salles et liens de billetterie."
        ]
      },
      "monaco": {
        "title": "Événements à Monaco",
        "seoTitle": "Agenda de Monaco — opéra, spectacles et concerts",
        "intro": [
          "Pour un État de deux kilomètres carrés, Monaco offre une programmation culturelle hors norme : opéra et ballet à la Salle Garnier de l'Opéra de Monte-Carlo, grands spectacles et concerts au Grimaldi Forum, théâtre au Théâtre Princesse Grace.",
          "Chaque mois de janvier, le Festival International du Cirque de Monte-Carlo investit le chapiteau de Fontvieille, et le printemps amène le Grand Prix. Voici tous les événements à venir que nous référençons à Monaco, avec dates, salles et liens de billetterie."
        ]
      },
      "antibes": {
        "title": "Événements à Antibes",
        "seoTitle": "Agenda d'Antibes et Juan-les-Pins",
        "intro": [
          "Antibes et Juan-les-Pins marient le charme de la vieille ville à une scène vivante : Anthéa, le théâtre moderne de la ville, programme théâtre, danse et concerts toute la saison, et les casinos et salles des environs ajoutent soirées d'humour et spectacles hommage.",
          "Chaque mois de juillet, Jazz à Juan — l'un des plus anciens festivals de jazz d'Europe — réunit des artistes internationaux dans la pinède Gould. Voici tous les événements à venir que nous référençons à Antibes et aux alentours, avec dates, salles et liens de billetterie."
        ]
      },
      "menton": {
        "title": "Événements à Menton",
        "seoTitle": "Agenda de Menton — concerts, théâtre et festivals",
        "intro": [
          "L'agenda mentonnais s'articule autour de deux grands rendez-vous : la Fête du Citron en février, quand les jardins se remplissent de sculptures géantes faites d'agrumes, et le Festival de Musique de Menton l'été, avec de la musique de chambre sur le parvis de la basilique Saint-Michel.",
          "Entre les deux, le Palais de l'Europe, le Casino Barrière et les églises de la ville accueillent concerts, pièces de théâtre et spectacles d'humour. Voici tous les événements à venir que nous référençons à Menton, avec dates, salles et liens de billetterie."
        ]
      },
      "sttropez": {
        "title": "Événements à Saint-Tropez",
        "seoTitle": "Agenda de Saint-Tropez — concerts et festivals",
        "intro": [
          "Saint-Tropez vit surtout l'été, quand concerts et soirées animent le port et les plages de Pampelonne. Mais les traditions du village rythment toute l'année : la Bravade en mai, procession séculaire en l'honneur du saint patron, et Les Voiles de Saint-Tropez, la régate de yachts classiques et modernes, entre fin septembre et début octobre.",
          "Hors saison, les concerts se replient dans les chapelles et les lieux culturels du village. Voici tous les événements à venir que nous référençons à Saint-Tropez, avec dates, salles et liens de billetterie."
        ]
      },
      "villefranche": {
        "title": "Événements à Villefranche-sur-Mer",
        "seoTitle": "Agenda de Villefranche-sur-Mer",
        "intro": [
          "Villefranche-sur-Mer est un petit port, et ses événements sont surtout locaux et saisonniers : concerts et expositions à la citadelle Saint-Elme, festivités estivales sur le front de mer et, à la fin de l'hiver, le Combat Naval Fleuri, quand des bateaux décorés défilent dans la rade en lançant des fleurs au public.",
          "Pour les grands concerts et spectacles, Nice est à dix minutes et Monaco à une vingtaine. Voici tous les événements à venir que nous référençons à Villefranche, avec dates, salles et liens de billetterie."
        ]
      }
    },
    "metaDescription_one": "{{count}} événement à venir {{inCity}} : {{list}}. Dates, salles et billets, mis à jour chaque jour.",
    "metaDescription_other": "{{count}} événements à venir {{inCity}} : {{list}}. Dates, salles et billets, mis à jour chaque jour.",
    "stats_one": "{{count}} événement à venir",
    "stats_other": "{{count}} événements à venir",
    "priceStat": "billets dès {{price}}",
    "citiesHeading": "Événements dans les autres villes de la Côte d'Azur",
    "nextHeading": "Prochainement {{inCity}}",
    "allHeading": "Tous les événements à venir {{inCity}}",
    "venuesHeading": "Salles",
    "faqHeading": "Événements {{inCity}} : questions fréquentes",
    "showAll": "Afficher les {{count}}",
    "showFewer": "Afficher moins",
    "allEvents": "Tous les événements de la Côte d'Azur",
    "loading": "Chargement des événements…",
    "empty": "Aucun événement à venir.",
    "listSeparator": ", ",
    "faq": {
      "whatQ": "Que faire {{inCity}} ? Quels sont les événements à venir ?",
      "whatA": "Nous référençons {{count}} événements à venir {{inCity}}, du {{first}} au {{last}} : {{list}}. La liste est mise à jour chaque jour, au fil des mises en vente.",
      "venuesQ": "Où ont lieu les concerts et spectacles {{inCity}} ?",
      "venuesA": "Les salles qui accueillent le plus d'événements à venir {{inCity}} sont {{list}}.",
      "ticketsQ": "Comment acheter des billets pour un événement {{inCity}} ?",
      "ticketsA": "Ouvrez un événement pour voir sa date, son horaire, sa salle et son prix de départ, puis suivez le lien de billetterie pour réserver auprès du vendeur officiel.",
      "ticketsPriceA": "Les billets pour les événements {{inCity}} commencent à {{price}}. Ouvrez un événement pour voir sa date, son horaire, sa salle et son prix de départ, puis suivez le lien de billetterie pour réserver auprès du vendeur officiel."
    }
  },
  "cityEventSlices": {
    "windows": {
      "today": {
        "title": "Que faire {{inCity}} aujourd'hui",
        "when": "aujourd'hui",
        "label": "Aujourd'hui"
      },
      "this-weekend": {
        "title": "Que faire {{inCity}} ce week-end",
        "when": "ce week-end",
        "label": "Ce week-end"
      },
      "this-week": {
        "title": "Que faire {{inCity}} cette semaine",
        "when": "dans les 7 prochains jours",
        "label": "Cette semaine"
      }
    },
    "categoryTitle": "{{category}} {{inCity}}",
    "categoryAnswer": "{{title}} : {{stats}}, {{range}}.",
    "windowCount_one": "{{count}} événement {{inCity}} {{when}}",
    "windowCount_other": "{{count}} événements {{inCity}} {{when}}",
    "range": "du {{first}} au {{last}}",
    "highlights": "À l'affiche : {{list}}.",
    "empty": "Aucun événement n'est encore annoncé {{inCity}} {{when}}.",
    "allHeading_one": "{{count}} événement",
    "allHeading_other": "Les {{count}} événements",
    "updated": "Mis à jour le {{date}}",
    "browseHeading": "Explorer l'agenda {{inCity}}",
    "allInCity": "Tout l'agenda",
    "loading": "Chargement des événements…"
  },
  "toursHub": {
    "intro": [
      "Visites guidées, excursions à la journée et expériences sur la Côte d'Azur, au départ de Nice, Cannes, Monaco, Antibes, Saint-Tropez, Menton et Villefranche-sur-Mer. Chaque excursion indique sa durée, la note des voyageurs, le prix de départ et un lien pour réserver sur Viator."
    ],
    "sections": [
      {
        "heading": "Les grandes excursions de la Riviera",
        "paragraphs": [
          "L'excursion la plus connue de la Riviera longe la côte à l'est de Nice : le village perché médiéval d'Èze, puis Monaco et Monte-Carlo — le Palais princier et la vieille ville sur le Rocher, le casino et le circuit du Grand Prix. Dans l'arrière-pays, les visites mènent à Saint-Paul-de-Vence et ses galeries d'art, à Grasse, capitale du parfum, et l'été plus loin en Provence, vers les champs de lavande et les gorges du Verdon.",
          "À l'ouest, Saint-Tropez et les roches rouges de l'Esterel occupent une journée au départ de Cannes ou de Nice ; à l'est, Menton est la dernière étape avant la frontière italienne."
        ]
      },
      {
        "heading": "Excursions par thème",
        "paragraphs": [
          "Au-delà des visites, il y a les dégustations dans les vignobles de Bellet et des Côtes de Provence, les balades gourmandes dans les marchés et les vieilles villes, les sorties en bateau et le snorkeling le long de la côte, les visites à vélo électrique ou à pied. Les visites privées avec chauffeur-guide sont courantes ici : c'est le moyen le plus simple d'enchaîner plusieurs villages dans la journée, et un choix fréquent pour les croisiéristes qui font escale à Villefranche-sur-Mer ou à Monaco."
        ]
      },
      {
        "heading": "Comment réserver",
        "paragraphs": [
          "Les excursions se réservent sur Viator, qui encaisse le paiement et envoie la confirmation avec le point de rendez-vous. Beaucoup d'excursions au départ de Nice et de Cannes incluent la prise en charge à l'hôtel, et beaucoup sont annulables gratuitement jusqu'à 24 heures avant le départ — les deux sont indiqués sur chaque excursion avant la réservation."
        ]
      }
    ],
    "citiesHeading": "Excursions par ville",
    "faqHeading": "Excursions sur la Côte d'Azur : questions fréquentes",
    "faq": [
      {
        "q": "Quelles sont les plus belles excursions sur la Côte d'Azur ?",
        "a": "Les classiques : Èze et Monaco sur la côte à l'est de Nice, Saint-Paul-de-Vence et Grasse dans l'arrière-pays, Saint-Tropez à l'ouest. L'été, les champs de lavande de Provence et les gorges du Verdon sont des sorties à la journée très prisées."
      },
      {
        "q": "Visite en groupe ou privée ?",
        "a": "Les visites en petit groupe sont la façon la plus économique de voir les grands sites. Une visite privée avec chauffeur-guide coûte plus cher mais choisit son rythme et son itinéraire — pratique en famille, pour enchaîner plusieurs villages ou pour les croisiéristes à l'horaire contraint."
      },
      {
        "q": "Faut-il une voiture ?",
        "a": "Non. Les excursions à la journée incluent le transport, et beaucoup prennent en charge à l'hôtel ou à un point de rendez-vous central à Nice ou à Cannes. Entre les villes de la côte, le TER qui longe le littoral est aussi une option simple."
      },
      {
        "q": "En quelle langue se déroulent les visites ?",
        "a": "La plupart des visites en groupe sont guidées en anglais, certaines aussi en français ou dans d'autres langues — les langues proposées sont indiquées sur Viator. Pour un guide francophone garanti, une visite privée est souvent la solution la plus simple."
      },
      {
        "q": "Peut-on annuler une réservation ?",
        "a": "Beaucoup d'excursions sont annulables gratuitement jusqu'à 24 heures avant le départ, mais les conditions varient — elles sont indiquées sur chaque excursion avant la réservation sur Viator."
      },
      {
        "q": "Comment les excursions sont-elles classées ?",
        "a": "Selon les avis des voyageurs : une note compte d'autant plus qu'elle repose sur beaucoup d'avis, si bien qu'une excursion saluée par des centaines de voyageurs passe devant une note parfaite issue de quelques avis."
      }
    ]
  },
  "hubFilters": {
    "sort": "Trier",
    "reset": "Réinitialiser",
    "retry": "Réessayer",
    "loadError": "Impossible de charger les résultats. Veuillez réessayer.",
    "noResults": "Aucun résultat pour ces filtres.",
    "sortOptions": {
      "recommended": "Recommandés",
      "price_asc": "Prix croissant",
      "price_desc": "Prix décroissant",
      "reviews": "Les plus commentés",
      "newest": "Année de construction : récente",
      "soonest": "Les plus proches"
    },
    "sortBuildYear": "Année de construction",
    "duration": "Durée",
    "durationOptions": {
      "any": "Toutes durées",
      "short": "Jusqu'à 3 heures",
      "half": "3 à 6 heures",
      "full": "Plus de 6 heures"
    },
    "when": "Quand",
    "whenOptions": {
      "any": "Toutes les dates",
      "today": "Aujourd'hui",
      "tomorrow": "Demain",
      "weekend": "Ce week-end",
      "week": "7 prochains jours",
      "month": "30 prochains jours"
    },
    "category": "Catégorie",
    "format": "Privé / groupe",
    "formatOptions": {
      "any": "Privé et groupe",
      "group": "En groupe",
      "private": "Privé"
    },
    "price": "Prix",
    "pricePerDay": "Prix par jour",
    "priceAny": "Tous les prix",
    "priceUnder": "Moins de {{price}}",
    "priceBetween": "{{min}}–{{max}}",
    "priceOver": "{{price}} et plus",
    "boatType": "Type de bateau",
    "boatTypeOptions": {
      "any": "Tous les bateaux",
      "motorboat": "Bateaux à moteur",
      "rib": "Semi-rigides",
      "yacht": "Yachts",
      "sailboat": "Voiliers",
      "catamaran": "Catamarans",
      "nolicence": "Sans permis"
    },
    "toursCount_one": "{{count}} activité",
    "toursCount_other": "{{count}} activités",
    "boatsCount_one": "{{count}} bateau",
    "boatsCount_other": "{{count}} bateaux",
    "eventsCount_one": "{{count}} événement",
    "eventsCount_other": "{{count}} événements"
  },
  "cityTours": {
    "cities": {
      "nice": {
        "title": "Excursions et visites à Nice",
        "seoTitle": "Excursions et visites guidées à Nice",
        "intro": [
          "Nice est la principale base d'excursions de la Côte d'Azur. En ville, les grands classiques sont la visite à pied ou gourmande du Vieux-Nice — socca, pissaladière et marché du cours Saleya — et les balades à vélo ou en segway le long de la Promenade des Anglais jusqu'à la colline du Château.",
          "Depuis Nice, les excursions d'une demi-journée ou d'une journée partent vers l'est par les corniches jusqu'à Èze et Monaco, vers l'ouest jusqu'à Saint-Paul-de-Vence et Grasse, et dans l'arrière-pays jusqu'aux gorges du Verdon. Voici toutes les activités que nous référençons à Nice, classées par durée et par note des voyageurs."
        ]
      },
      "cannes": {
        "title": "Excursions et visites à Cannes",
        "seoTitle": "Excursions à Cannes — îles de Lérins et arrière-pays",
        "intro": [
          "À Cannes, les demi-journées les plus prisées se passent sur l'eau : des bateaux quittent le vieux port pour les îles de Lérins, où l'île Sainte-Marguerite abrite le fort du Masque de fer et l'île Saint-Honorat une abbaye en activité, avec son propre vignoble. À terre, les visites guidées montent de la Croisette au Suquet, le vieux quartier.",
          "Cannes est aussi à portée de Grasse et de ses parfumeries, des roches rouges de l'Esterel et des villages perchés de l'arrière-pays. Voici toutes les activités que nous référençons à Cannes, classées par durée et par note des voyageurs."
        ]
      },
      "monaco": {
        "title": "Excursions et visites à Monaco",
        "seoTitle": "Visites à Monaco — Monte-Carlo et excursions",
        "intro": [
          "Monaco se découvre facilement à pied : les visites guidées associent généralement le Rocher — Palais princier, cathédrale et Musée océanographique — à la place du Casino de Monte-Carlo et à une portion du circuit de Formule 1.",
          "Monaco est aussi un bon point de départ pour longer la côte jusqu'à Èze et Menton, ou passer la frontière vers la Riviera italienne. Voici toutes les activités que nous référençons à Monaco, classées par durée et par note des voyageurs."
        ]
      },
      "antibes": {
        "title": "Excursions et visites à Antibes",
        "seoTitle": "Visites à Antibes — vieille ville et cap d'Antibes",
        "intro": [
          "Antibes associe une vieille ville fortifiée à l'un des plus beaux littoraux de la Côte d'Azur. Les visites parcourent les remparts, le marché provençal et le musée Picasso du château Grimaldi, ou suivent le sentier du littoral autour du cap d'Antibes.",
          "Depuis Antibes, Saint-Paul-de-Vence, Grasse et Cannes sont à courte distance, et des sorties en mer partent de Port Vauban, l'un des plus grands ports de plaisance d'Europe. Voici toutes les activités que nous référençons à Antibes, classées par durée et par note des voyageurs."
        ]
      },
      "menton": {
        "title": "Excursions et visites à Menton",
        "seoTitle": "Visites à Menton — jardins, Italie et excursions",
        "intro": [
          "Menton est la ville-jardin de la Côte d'Azur : son climat doux permet aux citronniers et aux plantes subtropicales de pousser en pleine terre, et des visites guidées ouvrent des jardins comme le Val Rahmeh ou la Serre de la Madone. Les visites à pied grimpent les escaliers de la vieille ville jusqu'à la basilique Saint-Michel.",
          "L'Italie commence aux portes de la ville : de nombreuses excursions depuis Menton passent la frontière pour le marché du vendredi de Vintimille, Dolceacqua ou Sanremo, tandis que d'autres filent vers Monaco et Èze. Voici toutes les activités que nous référençons à Menton, classées par durée et par note des voyageurs."
        ]
      },
      "sttropez": {
        "title": "Excursions et visites à Saint-Tropez",
        "seoTitle": "Excursions à Saint-Tropez — en bateau et dans les vignes",
        "intro": [
          "Saint-Tropez se découvre d'abord depuis la mer : les promenades en bateau longent les villas de la baie des Canebiers et les plages de Pampelonne. À terre, le port, la Citadelle et la place des Lices se prêtent à une visite à pied.",
          "La presqu'île est aussi un pays de rosé : les dégustations dans les vignobles de Ramatuelle et de Gassin comptent parmi les activités les plus réservées, tout comme les sorties vers les villages perchés et les îles d'Hyères. Voici toutes les activités que nous référençons à Saint-Tropez, classées par durée et par note des voyageurs."
        ]
      },
      "villefranche": {
        "title": "Excursions et visites à Villefranche-sur-Mer",
        "seoTitle": "Excursions depuis Villefranche-sur-Mer — escales de croisière",
        "intro": [
          "Villefranche-sur-Mer est l'un des ports de croisière les plus fréquentés de Méditerranée : beaucoup de ses excursions sont calées sur l'escale d'un navire — Monaco, Èze et Nice dans la journée, ou une boucle plus courte autour du cap Ferrat et de la villa Ephrussi de Rothschild.",
          "Si vous logez sur place, le port, la citadelle et la rue Obscure — une rue médiévale couverte — figurent au programme des visites à pied. Voici toutes les activités que nous référençons à Villefranche, classées par durée et par note des voyageurs."
        ]
      }
    },
    "metaDescription_one": "Comparez {{count}} activité {{inCity}}, dès {{price}} par personne — notée par les voyageurs et réservable sur Viator.",
    "metaDescription_other": "Comparez {{count}} excursions et visites {{inCity}}, dès {{price}} par personne : balades courtes, demi-journées et journées complètes, notées par les voyageurs. Réservation sur Viator.",
    "stats_one": "{{count}} activité",
    "stats_other": "{{count}} activités",
    "priceStat": "dès {{price}} par personne",
    "ratingStat": "note moyenne {{rating}}/5",
    "citiesHeading": "Excursions dans les autres villes de la Côte d'Azur",
    "durations": {
      "short": "Visites courtes (jusqu'à 3 heures)",
      "halfDay": "Demi-journées (3 à 6 heures)",
      "fullDay": "Excursions à la journée",
      "unknown": "Autres activités"
    },
    "faqHeading": "Excursions {{inCity}} : questions fréquentes",
    "allTours": "Toutes les excursions de la Côte d'Azur",
    "loading": "Chargement des activités…",
    "empty": "Aucune activité trouvée.",
    "listSeparator": " ; ",
    "faq": {
      "priceQ": "Combien coûte une excursion {{inCity}} ?",
      "priceA": "Les activités {{inCity}} commencent à {{min}} par personne, et la moitié coûte {{median}} ou moins. Les visites privées et les excursions à la journée avec transport sont plus chères — chaque offre sur Viator précise ce qui est inclus.",
      "bestQ": "Quelles sont les excursions les mieux notées {{inCity}} ?",
      "bestA": "Les activités les mieux notées {{inCity}}, d'après les avis des voyageurs : {{list}}.",
      "bestItem": "{{title}} ({{rating}}/5, {{reviews}} avis)",
      "durationQ": "Combien de temps durent les excursions {{inCity}} ?",
      "durationA": "Sur les {{count}} activités que nous référençons {{inCity}} : {{list}}.",
      "bookQ": "Comment réserver une excursion {{inCity}} ?",
      "bookA": "Toutes les activités présentées ici se réservent sur Viator, qui affiche les disponibilités en temps réel, le point de rendez-vous ou de prise en charge et les conditions d'annulation pour votre date."
    }
  },
  "footer": {
    "sisterSites": "Nos autres guides :",
    "tagline": "Événements, excursions, dégustations de vin et location de bateaux sur la Côte d'Azur — Nice, Cannes, Monaco, Antibes, Saint-Tropez, Menton et Villefranche-sur-Mer.",
    "thingsToDo": "Que faire",
    "events": "Agenda",
    "tours": "Excursions",
    "boatRental": "Location de bateau",
    "wineTours": "Œnotourisme",
    "language": "Langue",
    "disclosure": "Riviera To-Do est un guide indépendant. Certains liens sont des liens affiliés : lorsque vous réservez auprès de nos partenaires (Viator, Fnac Spectacles, Click&Boat), nous pouvons percevoir une commission, sans surcoût pour vous."
  }
}
